import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface CvRecommendation {
  section: string;
  suggestion: string;
}

export interface CvSectionFeedback {
  section: string;
  score: number;
  comment: string;
}

export interface CvAnalysis {
  candidatoId: number;
  cvId: number;
  jobId: string;
  matchScore: number;
  atsScore: number;
  missingKeywords: string[];
  recommendations: CvRecommendation[];
  cvText: string;
  limitado?: boolean;
  isPremium?: boolean;
  strengths?: string[];
  sectionFeedback?: CvSectionFeedback[];
}

@Injectable({ providedIn: 'root' })
export class CvOptimizerService {
  private base = `${environment.baseApi}/candidato/cv-optimizer`;

  constructor(private http: HttpClient) {}

  analyze(candidatoId: number, cvId: number): Observable<any> {
    return this.http.post(`${this.base}/analyze`, { candidatoId, cvId });
  }
}
